export * from './paramHistory.actions';


// WEBPACK FOOTER //
// src/main/components/paramHistory/store/actions/index.js